import React, { useEffect, useRef, useState } from 'react';
import { calculateNumberOfRows, MAXIMUM_NUMBER_OF_ROWS } from '../scroller-utils';
import IconsScroller from './IconsScroller';
import SportSelection from './SportSelection';

function SportSelectionMenu(props) {
    const el = useRef(null);
    const [scrollerEnabled, setScrollerEnabled] = useState(null);
    const isShopMode = window.appConfig?.SHOP_MODE;
    useEffect(() => {
        if (props.forceRows) {
            return;
        }
        let numberOfRows = calculateNumberOfRows(el.current);
        if (numberOfRows > MAXIMUM_NUMBER_OF_ROWS) {
            setScrollerEnabled(true);
        } else if(numberOfRows !== MAXIMUM_NUMBER_OF_ROWS) { // Chiudo lo scroller solo se  numberOfRows!=maximumNumberOfRows
            setScrollerEnabled(false);
        }
    }, [props.forceRows, props.sports]);
    useEffect(() => {
        if (!props.forceRows && el.current != null) {
            let numberOfRows = calculateNumberOfRows(el.current);
            if (numberOfRows > MAXIMUM_NUMBER_OF_ROWS) {
                setScrollerEnabled(true);
            } else if(numberOfRows !== MAXIMUM_NUMBER_OF_ROWS) { // Chiudo lo scroller solo se  numberOfRows!=maximumNumberOfRows
                setScrollerEnabled(false);
            }
        }
    }, [props.forceRows, props.sports]);

    const sportSelectionsList = props.sports.map(function(sp) {
        return (
            <SportSelection key={sp.id} {...sp} selected={sp.id === props.selected} changeSport={props.changeSport} />
        );
    });

    return (
        <div className={`container-slider-icone overflow-unset ${props.showSortButton ? (!isShopMode?'icons-slider-container-2':'icons-slider-container')  : 'w-100'} ` + (scrollerEnabled ? 'has-icons-container-no-wrap' : '')}>
            <div className={"containerElementiDropdown slider-icone-sport horiz-sc icons-container icons-container-no-arrow " + (scrollerEnabled ? 'icons-container-no-wrap' : '')} ref={el}>
                {sportSelectionsList}
            </div>
            <IconsScroller buttons={sportSelectionsList} iconsContainer={el.current} />
        </div>
    );
}

export default SportSelectionMenu;